import { educationalTabsContent } from './tabs';
import { useState } from 'react';
import { Buddy, EducationalTabsWrapper } from './EducationTabs.style';
import { Tabs } from '@linearb/linui-common';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';

/**
 * @returns {JSX.Element}
 */
export const EducationalTabs = () => {
  const [tabValue, setTabValue] = useState(0);

  /**
   *
   * @param {number} newValue
   */
  const onChange = newValue => {
    TrackingService.logEvent(TRACKING.EVENTS.EDU_SECTION_CLICKED, {
      name: educationalTabsContent[newValue].title,
      page: TRACKING.PAGES.DASHBOARD,
      event: TRACKING.EVENTS.CLICK
    });
    setTabValue(newValue);
  };

  return (
    <EducationalTabsWrapper data-testid='educational-tabs'>
      <Buddy />
      <Tabs
        tabDetails={educationalTabsContent}
        tabValue={tabValue}
        onChange={onChange}
      />
    </EducationalTabsWrapper>
  );
};
